import { getCountry } from '@iwIntlProvider/CountryProvider';
import { FormattedMessage } from 'react-intl';

import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals/MoneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';
import styles from '../EarlyRepayment.module.css';

const EarlyRepaymentFees = ({
    totalFees,
    isLoading
}: {
    totalFees: number;
    isLoading: boolean;
}) => {
    return (
        <SummaryRow isLoading={isLoading}>
            <FormattedMessage
                id="_.draw_down.choose_amount.fees"
                defaultMessage="Fees"
            />
            <div>
                {getCountry() === 'DE' && (
                    <span className={styles.always}>
                        <FormattedMessage
                            id="_.draw_down.choose_amount.always"
                            defaultMessage="always"
                        />
                    </span>
                )}
                <span data-testid="early-repayment-fees">
                    <MoneyWithDecimals value={totalFees} />
                </span>
            </div>
        </SummaryRow>
    );
};

// eslint-disable-next-line import/no-default-export
export default EarlyRepaymentFees;
